 
import { CLEAR_ALL_PARAMETERS } from '~~/constants/googleTagManager';
import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildClearAllFiltersParameters = ({
  categoryPath,
  categoryName,
  listingType,
}: {
  categoryPath: string,
  categoryName: string,
  listingType: EventSourceLocation
}) => ({
  event: CLEAR_ALL_PARAMETERS,
  event_info: {
    category_path: categoryPath,
    category_name: categoryName,
    listing_type: listingType,
  },
});
